import React, { ComponentProps } from "react";
import InputShell, { Props as InputShellProps } from "./InputShell";
import { cn } from "@/utils/cn";

type Props = {
  onChange: (newValue: string) => void;
  value: string;
  renderAction?: JSX.Element;
  actionPlacement?: "left" | "right";
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
} & Partial<Omit<InputShellProps, "children">> &
  Omit<ComponentProps<"input">, "onChange">;

const InputAction = ({
  label,
  error,
  isOptional,
  value,
  onChange,
  renderAction,
  actionPlacement = "right",
  className,
  inputClassName,
  disabled = false,
  optionalLabel,
  ...rest
}: Props) => {
  const inputShell = {
    label,
    error,
    ...(isOptional ? { isOptional, optionalLabel } : { required: rest.required })
  };

  return (
    <InputShell {...inputShell}>
      <div
        className={cn(
          "item-center flex min-h-[2.5rem] w-full rounded-[0.25rem] border border-outline transition-all focus-within:border-primary-base",
          actionPlacement === "left" && "flex-row-reverse",
          disabled && "bg-slate-100  text-slate-500",
          className
        )}
      >
        <input
          className={cn(
            "w-full border-none px-3 py-0 text-sm leading-4 placeholder:text-[#9BA5B7] focus:ring-0 disabled:bg-slate-100 disabled:text-slate-500",
            actionPlacement === "left"
              ? "rounded-br-[0.25rem] rounded-tr-[0.25rem]"
              : "rounded-bl-[0.25rem] rounded-tl-[0.25rem]",
            inputClassName
          )}
          title={label}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          autoComplete="off"
          disabled={disabled}
          placeholder={rest.placeholder}
          {...rest}
        />
        {renderAction && renderAction}
      </div>
    </InputShell>
  );
};

export default InputAction;
